const initialState = {
	isLoading: false,
	list: [],
	totalsize: 0,
};

function profileAutomateReducer(state = initialState, action) {
	switch (action.type) {
		case 'LOADING_THEME':
			return {
				...state,
				isLoading: action.payload
			};
		case 'LIST_THEME':
			return {
				...state,
				list: action.payload.listthemes,
				totalsize: action.payload.totalsize
			};
		default:
			return state;
	}
}

export default profileAutomateReducer;
